"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouchDevice = isTouchDevice;
const is_browser_1 = require("./is-browser");
/**
 * Проверяет поддержку touch событий.
 * @return True - если поддерживает, false - если нет.
 */
function isTouchDevice() {
    return (0, is_browser_1.isBrowser)() && 'ontouchstart' in window;
}
//# sourceMappingURL=is-touch-device.js.map